import React from "react";
import classNames from "classnames";
//--
import styles from "./Page.less";
//--
const Page = (props) => {
    return (React.createElement("div", { className: classNames(styles.pageContentRight, props.className && props.className) },
        React.createElement("div", { className: styles.pageContentRightMinSize }, props.children)));
};
export default Page;
//<div className={styles.container}>
//    {this.props.children}
//</div>
